import { credentialImportFields } from "@api/shared-runtime/credential-import-fields";
import type {
  ProviderFieldDraft,
  ProviderOffer,
  ProviderOfferSelection,
} from "../components/provider-imports/provider-import-types";

export function providerChangedFieldPaths(offer: ProviderOffer): string[] {
  return credentialImportFields(offer)
    .filter((field) => field.changed)
    .map((field) => field.path);
}

export function providerSelectedFieldPaths(
  offer: ProviderOfferSelection,
): string[] {
  return offer.selectedFieldPaths ?? providerChangedFieldPaths(offer);
}

/** Drafts live only in the open dialog. A changed snapshot always starts with
 * all fields selected; never carry exclusions onto different provider values. */
export function withProviderFieldDraft({
  offer,
  draft,
}: {
  offer: ProviderOffer;
  draft: ProviderFieldDraft | undefined;
}): ProviderOfferSelection {
  if (!draft || draft.expectedVersion !== offer.expectedVersion) {
    return offer;
  }
  const changedPaths = providerChangedFieldPaths(offer);
  const selectedFieldPaths = changedPaths.filter((path) =>
    draft.selectedFieldPaths.includes(path),
  );
  if (selectedFieldPaths.length === changedPaths.length) {
    return offer;
  }
  return { ...offer, selectedFieldPaths };
}

export function hasProviderImportChanges(
  offer: ProviderOfferSelection,
): boolean {
  if (!offer.isActionable) {
    return false;
  }
  if (offer.selectedFieldPaths === undefined) {
    return true;
  }
  return offer.selectedFieldPaths.length > 0 || offer.newDocumentCount > 0;
}
